import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { FC } from 'react';
import { TDeleteDialogProps } from './types';

export const DeleteDialog: FC<TDeleteDialogProps> = ({
	open,
	setClose,
	handleDelete,
	text,
	buttonName = 'Delete',
}) => {
	return (
		<Dialog
			open={open}
			onClose={setClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">{text}</DialogTitle>
			<DialogActions>
				<Button onClick={setClose}>Cancel</Button>
				<Button onClick={handleDelete} autoFocus>
					{buttonName}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
